





































































































































































































































































































































































































































































































































































































































































































































import { Component, Mixins, Vue, Prop } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import menuList from './data/menuList';
import MyQuestionMixin from '@/views/questionnaire/mixins/createQuestion';
@Component
export default class PHeader extends Mixins(MyQuestionMixin) {
  // @Prop({
  //   default: () => ({}),
  // })
  // public userInfo?: any = {};
  @Action('user/getUserInfo') public getUserInfo: any;
  @Getter('app/actionMenu') public actionMenu: any;
  @Getter('user/isLogin') public isLogin: any;
  // @Getter("user/userInfo") declare userInfo: any;
  private isShow: any = false;

  private onlineTestVisible: any = false;
  private onlineTestVisibleH5: any = false;
  private onlineTestVisibleProd: any = false;
  private onlineTestVisibleProdH5: any = false;
  private questionnaireVisible: any = false;
  private applyVisible: any = false;
  private messageList: any = null;
  private bgColor: any = null;
  private noShadow: any = false;
  private showInstallButton: any = false; // 用来判断当前浏览器是否支持安装
  private installPromptEvent: any = null; // 实例对象
  private headerPages1200: any = ['homeIndex', 'article', 'template', 'voteDetail', 'account', 'togetherIndex', 'memberIndex', 'programmeIndex', 'programmeDetail', 'homeIndexVote', 'homeIndexForm', 'homeIndexSurvey', 'homeIndexExam', 'homeIndexSolitaire', 'homeIndexOnline', 'homeIndexOrder', 'homeIndexEvaluation', 'questionDetail', 'bindingServicer', 'accountRecharge', 'transactionsRecord', 'task', 'mutual', 'accountBuyAI', 'buySmsAccound', 'buyAdvAccound', 'buyRiskAccound'];
  private listCount: any = {
    totalCount: 0,
    isReadCount: 0,
  };
  // 是否是在工作台
  get isWorking() {
    const parentTabs: any = ['voting', 'questionnaire', 'questionnaireExam', 'questionnaireForm', 'questionnaireOnline', 'questionnaireSolitaire', 'questionnaireAppoint'];
    const meta: any = this.$route.meta;
    if (parentTabs.indexOf(meta.parentTab) > -1) {
      return true;
    }
    return false;
  }
  /**
   * 退出登录
   */
  private async handleLogout() {
    try {
      await this.$store.dispatch('user/logout');
      if (this.$route.name !== 'homeIndex') {
        this.$router.push('/home');
      }
      this.$message.success('退出成功');
    } catch (error) {
      console.log(error);
    }
  }
  // 新建活动
  private handleCreate(routerName: any, name: any) {
    if (this.$store.getters['user/isLogin']()) {
      if (name === 'voting') {
        this.$router.push({
          name: routerName,
        });
      } else {
        this.mixin_createNewQuestion({ questionType: routerName }); // mixins里的方法
      }
    } else {
      this.$router.push({
        name: 'loginIndex',
      });
    }
  }
  // 跳转到爱凡凡 咨询
  private toConsult() {
    window.open('https://affim.baidu.com/unique_34249595/chat?siteId=18784727&userId=34249595&siteToken=1609f3fbd3223bb649632b9565eebc23', '_blank');
  }
  private mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // console.log(this.$route.meta.parentTab, "route");
  }
  // 顶部导航栏背景颜色
  private headerBgColor() {
    // $route.name === "homeIndex" ? "#deecff" : "#fff";
    if (this.$route.name === 'homeIndex' || this.$route.name === 'homeIndexVote' || this.$route.name === 'homeIndexForm' || this.$route.name === 'homeIndexSurvey' || this.$route.name === 'homeIndexExam' || this.$route.name === 'homeIndexEvaluation' || this.$route.name === 'homeIndexEvaluation' || this.$route.name === 'homeIndexSolitaire' || this.$route.name === 'homeIndexOnline' || this.$route.name === 'homeIndexOrder') {
      this.bgColor = 'transparent !important';
      this.noShadow = true;
    } else {
      this.bgColor = '#fff';
      this.noShadow = false;
    }
  }
  private handleScroll(e: any) {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
    if (this.$route.name === 'homeIndex' || this.$route.name === 'homeIndexVote' || this.$route.name === 'homeIndexForm' || this.$route.name === 'homeIndexSurvey' || this.$route.name === 'homeIndexExam' || this.$route.name === 'homeIndexEvaluation' || this.$route.name === 'homeIndexSolitaire' || this.$route.name === 'homeIndexOnline' || this.$route.name === 'homeIndexOrder') {
      if (scrollTop > 10) {
        this.bgColor = '#fff';
        this.noShadow = false;
      } else {
        this.bgColor = 'transparent !important';
        this.noShadow = true;
      }
    }
  }
  private toH5Maker() {
    window.open('https://user.longyixiu.com/', '_blank');
  }
  private notInLine() {
    this.$message.success('即将上线');
  }
  private handleToOnline() {
    window.open('https://affim.baidu.com/cps/chat?siteId=18784727&userId=34249595&siteToken=1609f3fbd3223bb649632b9565eebc23', '_blank');
  }
  /**
   * 去官网首页
   */
  private homePage() {
    this.$store.dispatch('app/actionMenuName', null);
    this.$router.push('/index');
  }
  /**
   * 去帮助与支持
   */
  private goArticle() {
    this.$router.push('/help.html');
    this.$store.dispatch('app/actionMenuName', 'article');
    // const { href } = this.$router.resolve({ name: "article" });
    // window.open(href, "_blank");
  }

  /**
   * 跳转到工作台
   */
  private goMyList() {
    let routesName = 'loginIndex';
    if (this.$store.getters['user/isLogin']()) {
      routesName = 'activeManagement';
      this.$router.push({ name: routesName });
    } else {
      const { href } = this.$router.resolve({
        name: routesName,
      });
      window.open(href, '_blank');
    }
  }
  /**
   * 去模板案例
   */
  private goTemplate() {
    this.$router.push('/template/list.html');
    this.$store.dispatch('app/actionMenuName', 'template');
    // const { href } = this.$router.resolve({ name: "template" });
    // window.open(href, "_blank");
  }
  /**
   * 去投票评选、问卷调研、报名表单
   */
  private handleGoto(key: string) {
    // 判断是否已经登录
    if (this.$store.getters['user/isLogin']()) {
      this.$store.dispatch('app/actionMenuName', key);
      const list: any = menuList;
      const userMenu = list[key];
      if (list[key].length) {
        list[key][0].children && list[key][0].children.length ? this.$router.push(list[key][0].children[0].url) : this.$router.push(list[key][0].url);
      }
    } else {
      this.$router.push('/login');
      // const { href } = this.$router.resolve({ name: "loginIndex" });
      // window.open(href, "_blank");
    }
  }
  /**
   * 去帮助中心
   */
  private toArticle() {
    // this.$router.push("/account.html");
    const { href } = this.$router.resolve({ name: 'article' });
    window.open(href, '_blank');
  }
  /**
   * 去账户资料
   */
  private goAccount() {
    // this.$router.push("/account.html");
    const { href } = this.$router.resolve({ name: 'account' });
    window.open(href, '_blank');
  }
  /**
   * 去会员中心
   */
  private goMember() {
    // this.$router.push("/member.html");
    const { href } = this.$router.resolve({ name: 'memberIndex' });
    window.open(href, '_blank');
  }
  /**
   * 去我的下载
   */
  private goToDownload() {
    this.$router.push('/myDownload.html');
    // const { href } = this.$router.resolve({ path: "/collection.html" });
    // window.open(href, "_blank");
  }
  /**
   * 去我的收藏
   */
  private goCollection() {
    this.$router.push('/collection.html');
    // const { href } = this.$router.resolve({ path: "/collection.html" });
    // window.open(href, "_blank");
  }
  private handleSelect(key: any, keyPath: any) {
    console.log(key);
  }
  private goLogin() {
    const routesName = 'loginIndex';
    // if (this.$store.getters["user/isLogin"]()) {
    //   routesName = "votingList";
    // }
    const { href } = this.$router.resolve({
      name: routesName,
    });
    window.open(href, '_blank');
    // this.$router.push({ name: "loginIndex" });
  }
  private isPWAsupported() {
    var userAgent = navigator.userAgent; // 取得浏览器的userAgent字符串
    console.log(userAgent);
    var isChrome = navigator.userAgent.indexOf('Chrome') > -1; // 是否是谷歌
    console.log('谷歌' + isChrome); // 返回 true  则是 ，false  则不是
    return isChrome;
  }
  private installApp() {
    console.log(this.isPWAsupported());
    // 浏览器不支持
    if (!this.isPWAsupported()) {
      this.$message({
        message: '添加失败，当前浏览器不支持，推荐使用Chrome浏览器',
        center: true,
        customClass: '',
      });
      return;
    }
    if (this.installPromptEvent) {
      // 调用安装操作
      this.installPromptEvent.prompt();
    } else {
      this.$message({
        message: '已安装',
        center: true,
        customClass: 'to-desk-message',
      });
    }
  }
  private async created() {
    // 安装到桌面
    window.addEventListener('beforeinstallprompt', (event) => {
      // 防止默认的应用安装提示
      event.preventDefault();
      // 在Vue组件中保存事件对象
      this.installPromptEvent = event;
      // 显示安装按钮
      // this.showInstallButton = true;
    });
    if (this.isLogin() && !this.userInfo.username) {
      try {
        await this.getUserInfo();
      } catch (error) {
        console.log(error);
      }
    }

    if (this.$route.name === 'template') {
      this.$store.dispatch('app/actionMenuName', 'template');
    } else if (this.$route.name === 'article') {
      this.$store.dispatch('app/actionMenuName', 'article');
    } else if (this.$route.name === 'programmeIndex') {
      this.$store.dispatch('app/actionMenuName', 'programme');
    } else if (this.$route.name === 'CollaborationCasesIndex') {
      this.$store.dispatch('app/actionMenuName', 'CollaborationCasesIndex');
    }
    //  else {
    //   this.$store.dispatch("app/actionMenuName", "homeIndex");
    // }
    if (this.isLogin) {
      this.getMessageList();
      this.getListCount();
    }
    this.headerBgColor();
    // this.getMessageList();
    // this.getListCount();
  }
  /**
   * 消息列表
   */
  private getMessageList() {
    this.$apis.getMessageList({}).then((res: any) => {
      // console.log("getMessageList", res);
      this.messageList = res;
    });
  }
  /**
   * 信息数量
   */
  private getListCount() {
    this.$apis.getListCount({}).then((res: any) => {
      this.listCount = res;
    });
  }
  /**
   * 设置已读信息
   */
  private getReadMessage() {
    this.$apis.getReadMessage({}).then((res: any) => {
      // console.log("getMessageList", res);
      // this.messageList = res;
      this.getMessageList();
      this.getListCount();
    });
  }
  /**
   * 设置单个已读信息
   */
  private getReadSingleMessage(item: any) {
    if (!item.read) {
      this.$apis.getReadSingleMessage({ messageId: item.id }).then((res: any) => {
        this.getMessageList();
        this.getListCount();
      });
    }
    if (item.newsType && item.newsType === 10) {
      this.gorechargeRecord();
    }
    if (item.newsType && item.newsType === 12) {
      this.$router.push({
        path: '/member/index.html',
      });
    }
  }
  /**
   * 去发票
   */
  private gorechargeRecord() {
    this.$router.push({
      path: '/info.html',
    });
    // const { href } = this.$router.resolve({ path: '/member/index.html', query: {membernumber: '6'});
    // window.open(href, "_blank");
  }
}
